import addDays from "date-fns/addDays";

const accountTypeList = [
  { label: "Member", value: "member" },
  { label: "Not A Member", value: "non-member" },
  { label: "Organization", value: "organization" },
]

var date = new Date(), y = date.getFullYear(), m = date.getMonth();
export const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
  },
  {
    label: "Tomorrow",
    value: [addDays(new Date(), 1), addDays(new Date(), 1)],
  },
  {
    label: "Next 7 days",
    value: [new Date(), addDays(new Date(), 7)],
  },
  {
    label: "Next 30 days",
    value: [new Date(), addDays(new Date(), 30)],
  },
  {
    label: "This month",
    value: [new Date(y, m, 1), new Date(y, m + 1, 0)],
  },
  {
    label: "Next month",
    value: [new Date(y, m + 1, 1), new Date(y, m + 2, 0)],
  },

];

const dateList = [
  { label: "This year", value: "year" },
  { label: "This month", value: "month" },
  { label: "This week", value: "week" },
  { label: "All time", value: "all" },
  { label: "Date range", value: "dateRange" },
];

export const filterList = [
  {
    name: "accountType",
    label: "Account Type",
    list: accountTypeList,
    type: "select",
  },
  {
    name: "languageType",
    label: "English/Hebrew",
    list: [
      { label: "English", value: "english" },
      { label: "Hebrew", value: "hebrew" },
    ],
    type: "select",
  },
  {
    name: "hasPlaque",
    label: "Has Plaque",
    type: "checkbox",
    className: "col-6 col-sm-4 col-md-2",
  },
  {
    name: "hasMourner",
    label: "Doesn't Have a Mourner",
    type: "checkbox",
  },
  // {
  //   name: "dateType",
  //   label: "Date",
  //   list: dateList,
  //   type: "select",
  // },
]
